import React, { useCallback } from 'react';
import { Label } from '@gravity-ui/uikit';
import { block } from '../../utils/cn';
import i18n from './i18n';
import './LabelFilterItem.css';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var b = block('label-filters-item');
export function LabelFilterItem(_ref) {
  var name = _ref.name,
    value = _ref.value,
    onItemRemove = _ref.onItemRemove,
    className = _ref.className;
  var onItemRemoveCallback = useCallback(function () {
    onItemRemove(name);
  }, [name, onItemRemove]);
  var type = name.startsWith('cluster') ? 'cluster' : name;
  return /*#__PURE__*/_jsx("div", {
    className: b({
      type: name
    }, className),
    children: /*#__PURE__*/_jsxs(Label, {
      type: "close",
      onClose: onItemRemoveCallback,
      className: b('label'),
      children: [i18n(type), ": ", value]
    })
  });
}
// #sourceMappingURL=LabelFilterItem.js.map